import { UserRole } from "../types/user";

export const MANAGEMENT_ROLES: UserRole[] = [
  UserRole.admin,
  UserRole.site_admin,
  UserRole.operator
];

export const USER_MANAGEMENT_ROLES: UserRole[] = [
  UserRole.admin,
  UserRole.site_admin
];

export const SITE_MANAGEMENT_ROLES: UserRole[] = [
  UserRole.admin,
  UserRole.site_admin
];

export const EQUIPMENT_IMPORT_ROLES: UserRole[] = [
  UserRole.admin,
  UserRole.site_admin
];

export const isSdiAdmin = (role?: UserRole | null): boolean => role === UserRole.admin;

export const isSiteAdmin = (role?: UserRole | null): boolean => role === UserRole.site_admin;

export const canAccessAdminDashboard = (role?: UserRole | null): boolean =>
  !!role && MANAGEMENT_ROLES.includes(role);

export const canManageUsers = (role?: UserRole | null): boolean =>
  !!role && USER_MANAGEMENT_ROLES.includes(role);

export const canManageSites = (role?: UserRole | null): boolean =>
  !!role && SITE_MANAGEMENT_ROLES.includes(role);

export const canImportEquipment = (role?: UserRole | null): boolean =>
  !!role && EQUIPMENT_IMPORT_ROLES.includes(role);

export const getRoleLabel = (role: UserRole): string => {
  switch (role) {
    case UserRole.admin:
      return "Admin SDI";
    case UserRole.site_admin:
      return "Admin site";
    case UserRole.operator:
      return "Opérateur";
    default:
      return role;
  }
};
